import { RichTextContent } from "@/features/post/components/common/RichTextContent";
import { PostDetailFragment, PostTypeEnum } from "@/generated/generated-hooks";

import { PostPassageMask } from "./PostPassageMask";

export function PostContent({ post }: { post: PostDetailFragment }) {
  const {
    postType,
    previewContent,
    content,
    isUserContentLocked,
    isPublished,
    userBlurLevel,
  } = post;

  if (
    !isPublished ||
    (postType === PostTypeEnum.Article && isUserContentLocked) ||
    (postType != PostTypeEnum.Article && userBlurLevel > 0)
  ) {
    // check if unlocked by subscription plan
    // user not subscribed --> display preview only
    return (
      <div className="relative max-h-1rem overflow-hidden text-ellipsis">
        <RichTextContent
          content={content?.serialized?.slice(0, 40) ?? ""}
          showAll={false}
        />

        <div className="absolute bottom-0 h-full w-full bg-gradient-to-t from-white via-white to-white/40 z-50">
          {/* <PostPassageMask post={post} /> */}
        </div>
      </div>
    );
  }

  return <RichTextContent content={content?.serialized} showAll={true} />;
}
